import styles from './IndustryCard.module.css';

interface IndustryCardProps {
  icon: string;
  industry: string;
  description: string;
  outcomes?: string[];
}

export function IndustryCard({ icon, industry, description, outcomes }: IndustryCardProps) {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <div className={styles.iconWrapper}>
          <span className={styles.icon} aria-hidden="true">{icon}</span>
        </div>
        <h3 className={styles.industry}>{industry}</h3>
      </div>
      <p className={styles.description}>{description}</p>
      {outcomes && outcomes.length > 0 && (
        <div className={styles.outcomes}>
          {outcomes.map((outcome) => (
            <div key={outcome} className={styles.outcome}>
              <span className={styles.outcomeCheck} aria-hidden="true">✓</span>
              {outcome}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
